import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, EventEmitter, ModelSignal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { TooltipModule } from 'primeng/tooltip';
import { IPHXOutputComponent } from '../../../../@core/interfaces/IPHXOutputComponent.interface';
import { Task } from '../../../../generated/generated-types';
import { getEntityEditLink, getTaskAttachedEntityTypeLabelKey } from '../../../../shared/utils/entity-edit-link';

@Component({
    selector: 'app-task-related-entity-column-widget',
    templateUrl: './task-related-entity-column-widget.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [CommonModule, RouterLink, TranslatePipe, TooltipModule],
})
export class TaskRelatedEntityColumnWidgetComponent implements IPHXOutputComponent {

    model: Task;
    modelSig?: ModelSignal<Task>;
    args: any;
    change = new EventEmitter<any>();

    get task(): Task | null {
        return this.modelSig ? this.modelSig() : this.model;
    }

    readonly entityTypeLabelKey = computed(() =>
        getTaskAttachedEntityTypeLabelKey(this.task?.relatedEntity?.type),
    );

    readonly entityLabel = computed(() => this.task?.relatedEntity?.label?.trim() ?? '');

    readonly editLink = computed(() =>
        getEntityEditLink(this.task?.relatedEntity?.type, this.task?.relatedEntity?.id),
    );

    readonly linkTooltip = computed(() => {
        const label = this.entityLabel();
        if (label) {
            return 'task.open-related-entity-with-label';
        }
        return 'task.open-related-entity';
    });

    readonly linkTooltipParams = computed(() => {
        const label = this.entityLabel();
        return label ? { label } : undefined;
    });

}
